import {t} from "@lingui/core/macro"

// Règle de validation Antd pour un champ téléphone rendu via <PhoneInput>.
// Même logique que le plugin identity du WebEditor (référence du tunnel public) :
// PhoneInput émet déjà du E164 (ou null) ; on revalide le format ici.
// `required` configurable selon le contexte.
export function phoneRules(required = false) {
    return [
        {required, message: t`Ce champ est obligatoire`},
        {
            validator: (_, value) => {
                if (!value) return Promise.resolve()
                const cleaned = String(value).replace(/[\s\-().]/g, "")
                return /^\+?[0-9]{6,20}$/.test(cleaned)
                    ? Promise.resolve()
                    : Promise.reject(new Error(t`Le numéro de téléphone est invalide`))
            },
        },
    ]
}
